module.exports = __webpack_public_path__ + "static/img/honorPadWater.99f89b6e.png";